import React from 'react';
import { connect } from 'react-redux';

import PageTitleComponent from '../shared/PageTitleComponent';
import BackgroundBannerComponent from '../shared/BackgroundBannerComponent';
//import BannerAudioPlayer from '../shared/BannerAudioPlayer';
import TourDescription from '../shared/TourDescription';
import TipsAndHours from '../shared/TipsAndHours';
import MapComponent from '../shared/MapComponent';
//import { Link } from 'react-router-dom';
import TourListItem from '../shared/TourListItem';

import { getTourByID, pageIsLoading, setCurrentlyPlaying } from '../../actions/tourActions';

const mapStateToProps = (state) => {
    return {
        currentTour: state.currentTour,
        pageIsLoading: state.pageIsLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getTourByID: (id) => dispatch(getTourByID(id)),
        setPageToLoading: () => dispatch(pageIsLoading()),
        setCurrentlyPlaying: (data) => dispatch(setCurrentlyPlaying(data))
    }
}

class TourContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showContent: 'lessContent'
        }

        this.openAudioPlayer = this.openAudioPlayer.bind(this);
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.getTourByID(id);

        this.toggleDescription = this.toggleDescription.bind(this);


    }

    componentWillMount() {
        this.props.setPageToLoading();
    }


    openAudioPlayer(item) {
        console.log(item);
        this.props.setCurrentlyPlaying(item);
        console.log('open the audio player');
    }

    toggleDescription() {
        //console.log('toggleDescription value');
        this.updateShowContentState()
    }

    updateShowContentState() {
        this.setState({
            showContent: this.state.showContent === 'lessContent' ? 'moreContent' : 'lessContent'
        });
    }


    render() {
        const { pageIsLoading, currentTour } = this.props;

        console.log(this.state.showContent);

        if (pageIsLoading === false) {
            let tourList = null;

            let MapComponentOnRender = () => {
                if (currentTour.acf.map !== '' && currentTour.acf.map.lat !== null) {
                    return (
                        <MapComponent
                            latitude={currentTour.acf.map.lat}
                            longitude={currentTour.acf.map.lng}
                            address={currentTour.acf.map.address}
                            duration={parseInt(currentTour.acf.duration, 10)}
                        />
                    );
                }
                else {
                    return (
                        null
                    );
                }
            };


            if (typeof (currentTour.acf) === 'object' && currentTour.acf.interesting_locations !== false) {
                tourList = currentTour.acf.interesting_locations.map((location, index) => {
                    return (
                        <div key={index}>
                            {/*
                            <Link
                                onClick={this.props.setPageToLoading}
                                to={`/location/${location.id}`}>*/}
                            <div onClick={() => this.openAudioPlayer(location)}>
                                <TourListItem
                                    title={location.title.rendered}
                                    description={location['app-excerpt']}
                                    imageUrl={location.featured_image} />
                            </div>
                            {/*
                            </Link>
                            */}
                        </div>
                    );
                });
            }



            return (
                <div className="row">
                    <div className="col-md-7">
                        <PageTitleComponent title={currentTour.title.rendered} />
                        <BackgroundBannerComponent
                            imageUrl={currentTour.featured_image}>
                            {/*
                        <BannerAudioPlayer />
                        */}
                        </BackgroundBannerComponent>

                        <TourDescription
                            showContent={this.state.showContent}
                            toggleDescription={this.toggleDescription}
                            lessContent={currentTour['app-excerpt']}
                            moreContent={currentTour.content.rendered} />
                        <MapComponentOnRender />                        

                    </div>
                    <div className="col-md-5">
                    
                    <TipsAndHours tipsData={currentTour.acf['tips_&_hours']} />

                        <div className="app-tour-locations-list">
                            <h2>Locations</h2>
                            {tourList}
                        </div>

                    </div>
                </div>
            );
        }
        else {
            return (
                <div>
                    loading
                </div>
            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TourContainer);


// WEBPACK FOOTER //
// ./src/components/tour/TourContainer.js